import React from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import useApiUrls from "../../useApiUrls";

const UpdateCampaign = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get the campaign ID from the URL
  const { getUrlByOperation, error: urlError } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    id: id,
    campaignname: "",
    remark: "",
    active: true,
  });



  // State to hold API response or error
  const [message, setMessage] = useState("");

  // Fetch the existing data for the campaign
  useEffect(() => {
    if (id) {
      const fetchCampaignData = async () => {
        // const localStorageData = JSON.parse(localStorage.getItem("user"));
        // const token = localStorageData?.token;
        // const userid = localStorageData?.userid;
        const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

        try {
          const CampaignSearch = getUrlByOperation("CampaignSearch"); 
          const response = await axios.post(
            CampaignSearch,
            { id: id },
            {
              headers: {
                "X-Authorization": token,
                UserId: userid,
                "Content-Type": "application/json-patch+json",
              },
            }
          );

          if (response.data && Array.isArray(response.data.data)) {
            setFormData({
              ...response.data.data[0],
              // active: response.data.data[0].active === "Active" // Convert to boolean
            });
          }
        } catch (error) {
          console.error("Error fetching campaign data:", error);
          setMessage("Failed to fetch campaign data.");
        }
      };

      fetchCampaignData();
    }
  }, [id, getUrlByOperation]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "active" ? value === "Active" : value, // Convert active to boolean
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    // Create an object with only the fields that should be sent in the update request
    const updateData = {
      id: formData.id,
      active: formData.active, // Ensure it's a boolean value
      campaignname: formData.campaignname,
      remark: formData.remark,
    };

    try {
      // Update existing campaign
      const CampaignUpadte = getUrlByOperation("CampaignUpadte"); 
      await axios.post(
        CampaignUpadte,
        updateData, // Send only the necessary fields
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );
      setMessage("Campaign updated successfully!");

      // Set a delay before navigating
      setTimeout(() => {
        navigate("/compaign");
      }, 3000);
    } catch (error) {
      setMessage("Failed to update campaign.");
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">
                        {id ? "Update" : "Add"} Campaign
                      </h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.campaignname}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="campaignname"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="remark"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active ? "Active" : "Deactive"}
                                onChange={handleChange}
                              >
                                <option value="Active">Active</option>
                                <option value="Deactive">Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            {id ? "Update" : "Add"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {message === "Campaign updated successfully!" ? (
        <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to update campaign" ? (
       <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default UpdateCampaign;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
